import { createContext } from "react";
import * as Cesium from "cesium";
import { EncripTionOptionType, SecurityConfigDetailsType, SecurityConfigFormData } from "../CommonComponents/security-configuration/types";
import { AllOnBoardSchedule, ConsoleFilterOptionType, ContactStation, CustomScheduleModalDataType, GroundStation, LaunchDetails, LoaderTypes, Modals, OnboardScheduleDetailsType, Orbit, OrbitParams, RemoteComponentsType, RemoteConnectionStatusType, ScenarioDeploymentDetails, ScenarioResponseType, ScheduleConfirmationModalType, ScheduleTask, SelectedContact, SelectedSatelliteType, SimulationTime, TaskPlanDetails } from "./types";
import { MenuState, TelemetryConfirmState, TelemetryDashboardConfigType, TelemetryPanel, TelemetryStatusType, UnitSystem } from "./components/center/telemetry/lib/dashboard-types";
import { TelemetrySeries } from "./components/center/telemetry/lib/telemetry-types";
import { TelemetryLayoutMode, TelemetryViewportState } from "../CommonComponents/telemetry";

export interface CommandCenterStateProviderContextType {
    error: {
        header: string;
        message: string;
    } | null;
    setError: (error: {
        header: string;
        message: string;
    } | null) => void;

    commandCenterLoader: LoaderTypes;
    setCommandCenterLoader: (loader: any) => void;

    socket: WebSocket | null;
    setSocket: (socket: WebSocket | null) => void;

    scenario: ScenarioResponseType | null;
    set_scenario: (scenario: ScenarioResponseType) => void;
    deploymentSessionType: string | null;
    setDeploymentSessionType: React.Dispatch<React.SetStateAction<string | null>>;
    satellites: SelectedSatelliteType[] | null;
    set_satellites: (satellites: SelectedSatelliteType[] | null) => void;
    selected_satellite: SelectedSatelliteType | null;
    grpGrafanaData: any[];
    setGrpGrafanaData: (data: any[]) => void;
    unDeployLoader: boolean | {};
    setUnDeployLoader: (unDeployLoader: boolean | {}) => void;
    set_selected_satellite: (scenario: SelectedSatelliteType) => void;
    simulation_time: SimulationTime,
    set_simulation_time: (data: SimulationTime) => void;
    grafana: any;
    set_grafana: (data: any) => void;
    telemetry_time: [Date | null, Date | null] | null;
    set_telemetry_time: (time: [Date | null, Date | null] | null) => void;

    remoteAppLoader: boolean;
    setRemoteAppLoader: React.Dispatch<React.SetStateAction<boolean>>;
    allRemoteApplications: RemoteComponentsType;
    setAllRemoteApplications: React.Dispatch<React.SetStateAction<RemoteComponentsType>>;
    remoteConnectionStatus: RemoteConnectionStatusType[];
    setRemoteConnectionStatus: React.Dispatch<React.SetStateAction<RemoteConnectionStatusType[]>>;
    remoteConnectionModal: boolean;
    setRemoteConnectionModal: React.Dispatch<React.SetStateAction<boolean>>;

    selected_satellite_group: any;
    set_selected_satellite_group: (data: any) => void;
    satellite_groups: any;
    set_satellite_groups: (data: any) => void;

    viewer: Cesium.Viewer | null;
    set_viewer: (data: any) => void;
    multiplier: number;
    set_multiplier: (data: number) => void;
    viewer_state: 'play' | 'pause';
    set_viewer_state: (data: 'play' | 'pause') => void;
    current_simulation_time: number;
    set_current_simulation_time: (data: number) => void;

    all_ground_stations: GroundStation[];
    set_all_ground_stations: (data: GroundStation[]) => void;
    selectedScheduleTask: {
        default_schedule: boolean;
        schedule_data: ScheduleTask;
    };
    setSelectedScheduleTask: (data: {
        default_schedule: boolean;
        schedule_data: ScheduleTask;
    }) => void;
    selectedContact: SelectedContact;
    setSelectedContact: React.Dispatch<React.SetStateAction<SelectedContact>>;
    contacts: {
        previous_contacts: null | ContactStation[],
        ongoing_contacts: null | ContactStation[],
        upcoming_contacts: null | ContactStation[]
        current_time: null | number,
    }
    configured_gs: GroundStation[];
    setContacts: (data: {
        previous_contacts: null | ContactStation[],
        ongoing_contacts: null | ContactStation[],
        upcoming_contacts: null | ContactStation[]
        current_time: null | number,
    }) => void;
    timelineContactData: ContactStation[];
    planingContactData: ContactStation[];
    scheduleData: ScheduleTask[];
    timelineScheduleData: ScheduleTask[];
    scheduleDetails: {
        start_time: number,
        name: string,
    };
    allOnBoardSchedule: AllOnBoardSchedule;
    selectedSchedule: null | string;
    setScheduleDetails: (details: {
        start_time: number,
        name: string,
    }) => void;
    setScheduleData: (data: ScheduleTask[]) => void;
    setTimelineScheduleData: (data: ScheduleTask[]) => void;
    setSelectedSchedule: (schedule: null | string) => void;
    setAllOnBoardSchedule: (data: AllOnBoardSchedule) => void;
    setPlaningContactData: (data: ContactStation[]) => void;
    setTimelineContactData: (data: ContactStation[]) => void;
    set_configured_gs: (data: GroundStation[]) => void;

    orbitData: Orbit | null,
    orbitParams: OrbitParams,
    launchDetails: LaunchDetails[],
    setOrbitData: (data: Orbit | null) => void,
    setOrbitParams: (data: OrbitParams) => void,
    setLaunchDetails: (data: LaunchDetails[]) => void,

    supportedSystemFaults: any,
    setSupportedSystemFaults: (data: any) => void,
    injectedFaultList: any
    setInjectedFaultList: (data: any) => void,

    modals: Modals[],
    set_Modals: (modals: Modals[]) => void,

    overlayData: {
        overlay: string;
        data: any;
        position: { x: number, y: number };
    } | null,
    setOverlayData: (data: {
        overlay: string;
        data: any;
        position: { x: number, y: number };
    } | null) => void,
    //--------console filters--------//
    consoleFilterOptions: any,
    setConsoleFilterOptions: (data: any) => void,
    consoleFilterGroups: Map<string, ConsoleFilterOptionType>,
    setConsoleFilterGroups: React.Dispatch<React.SetStateAction<Map<string, ConsoleFilterOptionType>>>,
    originalFilterMetadata: any,
    setOriginalFilterMetadata: (data: any) => void,
    referenceIdConsole: string | null,
    setReferenceIdConsole: (id: string | null) => void;
    //-------------------------------//
    highlightedCommands: Set<string>;
    setHighlightedCommands: (updateFn: (prev: Set<string>) => Set<string>) => void;

    //FILE TRANSFER// --> GROUND FILES
    allACPStorageFiles: Record<string, Map<string, any>> | null;
    setAllACPStorageFiles: React.Dispatch<
        React.SetStateAction<Record<string, Map<string, any>> | null>
    >;
    progessOfSatUpload: Map<string, number> | null;
    setProgressOfSatUpload: React.Dispatch<React.SetStateAction<Map<string, number> | null>>;
    allDestinationIds: any[] | null,
    setAllDestinationIds: (value: any[] | null) => void;
    isGroundFilesLoading: boolean,
    setIsGroundFilesLoading: (boolean) => void;
    //FILE TRANSFER// --> ONBOARD FILES
    allOnboardFiles: Record<string, Map<string, any>> | null;
    setAllOnboardFiles: React.Dispatch<React.SetStateAction<Record<string, Map<string, any>> | null>>;
    allDownlinkingFiles: Map<string, any> | null;
    setAllDownlinkingFiles: React.Dispatch<React.SetStateAction<Map<string, any> | null>>;
    isDownlinkqueueLoading: boolean,
    setIsDownlinkqueueLoading: (boolean) => void;
    downlinkHistoryFiles: Map<string, any> | null;
    setDownlinkHistoryFiles: React.Dispatch<React.SetStateAction<Map<string, any> | null>>;
    isOnboardFilesLoading: boolean,
    setIsOnboardFilesLoading: (boolean) => void;
    downlinkRefreshTime: number | null;
    setDownlinkRefreshTime: React.Dispatch<React.SetStateAction<number | null>>;
    isRefreshTimeLoading: boolean,
    setIsRefreshTimeLoading: (boolean) => void;

    //CUSTOM SCHEDULE STATES
    onboardScheduleDetails: OnboardScheduleDetailsType,
    setOnboardScheduleDetails: React.Dispatch<React.SetStateAction<OnboardScheduleDetailsType>>;
    customScheduleModalData: CustomScheduleModalDataType | null,
    setCustomScheduleModalData: React.Dispatch<React.SetStateAction<CustomScheduleModalDataType | null>>;

    taskPlanDetails: TaskPlanDetails,
    setTaskPlanDetails: React.Dispatch<React.SetStateAction<TaskPlanDetails>>;

    scheduleConfirmationModal: ScheduleConfirmationModalType | null,
    setScheduleConfirmationModal: React.Dispatch<React.SetStateAction<ScheduleConfirmationModalType | null>>;

    //SECURITY CONFIG STATES
    EncripTionOptions: EncripTionOptionType[];
    securityConfig: SecurityConfigDetailsType | null;
    setSecurityConfig: React.Dispatch<React.SetStateAction<SecurityConfigDetailsType | null>>;
    securityConfigFormData: SecurityConfigFormData;
    setSecurityConfigFormData: React.Dispatch<React.SetStateAction<SecurityConfigFormData>>;

    //TELEMETRY STATES
    telemetryDashboards: TelemetryDashboardConfigType | null;
    setTelemetryDashboards: React.Dispatch<React.SetStateAction<TelemetryDashboardConfigType | null>>;
    activeTelemetryDashboardId: string;
    setActiveTelemetryDashboardId: React.Dispatch<React.SetStateAction<string>>;
    expandedTelemetryPanel: TelemetryPanel | null;
    setExpandedTelemetryPanel: React.Dispatch<React.SetStateAction<TelemetryPanel | null>>;
    configPanel: TelemetryPanel | null;
    setConfigPanel: React.Dispatch<React.SetStateAction<TelemetryPanel | null>>;
    addModalOpen: boolean;
    setAddModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    insertGap: any;
    setInsertGap: React.Dispatch<React.SetStateAction<any>>;
    openTelemetryDropdownId: string | null;
    setOpenTelemetryDropdownId: React.Dispatch<React.SetStateAction<string | null>>;
    selectedTelemetryPanelId: string | null;
    setSelectedTelemetryPanelId: React.Dispatch<React.SetStateAction<string | null>>;
    telemetryConfirmState: TelemetryConfirmState | null;
    setTelemetryConfirmState: React.Dispatch<React.SetStateAction<TelemetryConfirmState | null>>;
    telemetryMenuState: MenuState | null;
    setTelemetryMenuState: React.Dispatch<React.SetStateAction<MenuState | null>>;
    telemetrySettingsOpen: boolean;
    setTelemetrySettingsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    telemetryPrecision: number;
    setTelemetryPrecision: React.Dispatch<React.SetStateAction<number>>;
    telemetryUnits: UnitSystem;
    setTelemetryUnits: React.Dispatch<React.SetStateAction<UnitSystem>>;
    telemetryTimeframe: number;
    setTelemetryTimeframe: React.Dispatch<React.SetStateAction<number>>;
    telemetryCustomStartTime: number | null;
    setTelemetryCustomStartTime: React.Dispatch<React.SetStateAction<number | null>>;
    telemetryLayoutMode: TelemetryLayoutMode;
    setTelemetryLayoutMode: React.Dispatch<React.SetStateAction<TelemetryLayoutMode>>;
    telemetrySeries: TelemetrySeries[];
    setTelemetrySeries: React.Dispatch<React.SetStateAction<TelemetrySeries[]>>;
    telemetryStatus: TelemetryStatusType;
    setTelemetryStatus: React.Dispatch<React.SetStateAction<TelemetryStatusType>>;
    isTelemetryListening: boolean;
    setIsTelemetryListening: React.Dispatch<React.SetStateAction<boolean>>;
    hasUnsavedChanges: boolean;
    setHasUnsavedChanges: React.Dispatch<React.SetStateAction<boolean>>;
    isTelemetryDataLoading: boolean;
    setIsTelemetryDataLoading: React.Dispatch<React.SetStateAction<boolean>>;
    scenarioDeploymentDetails: ScenarioDeploymentDetails | null;
    setScenarioDeploymentDetails: React.Dispatch<React.SetStateAction<ScenarioDeploymentDetails | null>>;
    telemetryViewport: TelemetryViewportState;
    setTelemetryViewport: React.Dispatch<React.SetStateAction<TelemetryViewportState>>;
    savedTelemetryDashboards: TelemetryDashboardConfigType | null;
    setSavedTelemetryDashboards: React.Dispatch<React.SetStateAction<TelemetryDashboardConfigType | null>>;
    isSavingTelemetryWorkspace: boolean;
    setIsSavingTelemetryWorkspace: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CommandCenterStateProviderContext = createContext<CommandCenterStateProviderContextType | undefined>(undefined);

